import {sendRequest, requestMethod} from './BaseApi'

const auth = {
    TRUE: true,
    FALSE: false
};

///////////////////////////////////////////////////////////
///admin:a, reseller:b, company:c,districtmanager:d
///////////////////////////////////////////////////////////

export const register=(requestObj)=>{
    return sendRequest(
        'auth/register',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}
export function signin(requestObj){
    return sendRequest(
        'auth/login',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Deletes this login's admin token on the server (the Bearer header identifies it)
export function adminLogout(){
    return sendRequest(
        'auth/adminLogout',
        requestMethod.POST,
        auth.FALSE,
        {},
    )
}

export function forgotPassword(requestObj){
    return sendRequest(
        'password/sendtoken',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export function changePassword(requestObj){
    return sendRequest(
        'password/change',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// //////////////////////////////////////////////////////////
//////


/////////////////////////////////////////////////////////////


export async function getDashboard(requestObj){
    var url ='dashboard/getDashboard'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function getGuards(requestObj){
    var url ='dashboard/getGuards'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function getPastGuards(requestObj){
    var url ='dashboard/getPastGuards'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function getAdminName(){
    var url ='dashboard/getAdminName'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        {}
    )
}

export async function updateReportParams(requestObj){
    var url ='dashboard/updateReportParams'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj
    )
}

export async function getReportParams(requestObj){
    var url ='dashboard/getReportParams'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj
    )
}

export async function getGraphicData(requestObj){
    var url ='dashboard/getGraphicData'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj
    )
}

export async function getDownloadData(requestObj){
    var url ='dashboard/getDownloadData'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj
    )
}

export async function getCompany(requestObj){
    var url = 'auth/company/get'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function updateCompany(requestObj){
    var url ='auth/company/update'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function stopCompany(requestObj){
    var url ='auth/company/stop'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function activeCompany(requestObj){
    var url ='auth/company/active'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}


// A country's time zones (App\TimeZones on the server): {country: 'GB'} -> {zones: ['Europe/London']}
export const getCountryTimezones = (requestObj) => {
    return sendRequest(
        'timezones/country',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const deleteCompany = (requestObj) => {
    var url ='auth/company/delete'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function deleteReseller(requestObj){
    var url ='auth/reseller/delete'
    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function getDistrictManager(requestObj){
    var url ='auth/districtManager'

    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function updateDistrictManager(requestObj){
    var url ='auth/districtManager/update'

    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}


// {id, password, password_confirmation}: a company admin, reseller or super-admin sets a district manager's password
export async function setDistrictManagerPassword(requestObj){
    return sendRequest(
        'auth/districtManager/password',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function deleteDistrictManager(requestObj){
    var url ='auth/districtManager/delete'

    return sendRequest(
        url,
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function getReseller(requestObj){
    var url ='auth/reseller/'
    if(requestObj!=undefined)
        url = 'auth/reseller/'+requestObj
    return sendRequest(
        url,
        requestMethod.GET,
        auth.FALSE,
        requestObj,
    )
}

export async function upload(requestObj){
    return sendRequest(
        'image/store',
        requestMethod.FILE,
        auth.FALSE,
        requestObj,
    )
}

///supervisor////////////////////////

///////////////////////////////////////


export const registerSupervisor=(requestObj)=>{
    return sendRequest(
        'supervisor/register',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function getSupervisor(requestObj){
    return sendRequest(
        'supervisor/get',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function updateSupervisor(requestObj){
    return sendRequest(
        'supervisor/update',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function deleteSupervisor(requestObj){
    return sendRequest(
        'supervisor/delete',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export async function unAssignGuard(requestObj){
    return sendRequest(
        'supervisor/unAssign',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

///client///////////////////////////

////////////////////////////////////

export const registerClient=(requestObj)=>{
    return sendRequest(
        'client/register',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}
export const getClient=(requestObj)=>{
    return sendRequest(
        'client/get',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const updateClient=(requestObj)=>{
    return sendRequest(
        'client/update',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const deleteClient=(requestObj)=>{
    return sendRequest(
        'client/delete',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

///Location///////////////////////////

////////////////////////////////////

export const registerLocation=(requestObj)=>{
    return sendRequest(
        'location/register',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}
export const getLocation=(requestObj)=>{
    return sendRequest(
        'location/get',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const updateLocation=(requestObj)=>{
    return sendRequest(
        'location/update',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const deleteLocation=(requestObj)=>{
    return sendRequest(
        'location/delete',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const registerGuard=(requestObj)=>{
    return sendRequest(
        'guard/register',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const getHitAccuracy=(requestObj)=>{
    var url ='guardapp/hitAccuracy/'
    if(requestObj!=undefined)
        url = 'guardapp/hitAccuracy/'+requestObj
    return sendRequest(
        url,
        requestMethod.GET,
        auth.FALSE,
    )
}

export const getGuard=(requestObj)=>{
    return sendRequest(
        'guard/get',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const getGuardUsage=(requestObj)=>{
    return sendRequest(
        'guardapp/getGuardUsageWeb',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const updateGuard=(requestObj)=>{
    return sendRequest(
        'guard/update',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const deleteGuard=(requestObj)=>{
    return sendRequest(
        'guard/delete',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const assignGuard=(requestObj)=>{
    return sendRequest(
        'guard/assign',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}
export const assignCancel=(requestObj)=>{
    return sendRequest(
        'guard/assignCancel',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const registerAlertTemplate=(requestObj)=>{
    return sendRequest(
        'alertTemplate/register',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}
export const getAlertTemplate=(requestObj)=>{
    return sendRequest(
        'alertTemplate/get',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const updateAlertTemplate=(requestObj)=>{
    console.log("999000")
    return sendRequest(
        'alertTemplate/update',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const deleteAlertTemplate=(requestObj)=>{
    console.log("999000")
    return sendRequest(
        'alertTemplate/delete',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

///district
//////////////////////////////////////////////////////////////////

export const registerDistrict=(requestObj)=>{
    return sendRequest(
        'district/register',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}
export const getDistrict=(requestObj)=>{
    return sendRequest(
        'district/get',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const updateDistrict=(requestObj)=>{
    return sendRequest(
        'district/update',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const deleteDistrict=(requestObj)=>{
    return sendRequest(
        'district/delete',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}


///duty
//////////////////////////////////////////////////////////////////

export const registerDuty=(requestObj)=>{
    return sendRequest(
        'duty/register',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}
export const getDuty=(requestObj)=>{
    return sendRequest(
        'duty/get',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}


export const updateDuty=(requestObj)=>{
    return sendRequest(
        'duty/update',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const deleteDuty=(requestObj)=>{
    console.log("delete duty",requestObj)
    return sendRequest(
        'duty/delete',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const getGuardDuty=(requestObj)=>{
    return sendRequest(
        'duty/getGuard',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const updateAlertValidate=(requestObj)=>{
    return sendRequest(
        'alert/validateAlert',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const validateAlertAdmin=(requestObj)=>{
    return sendRequest(
        'alert/validateAlertAdmin',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const getAlertEditHistory=(requestObj)=>{
    return sendRequest(
        'alert/getAlertEditHistory',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

export const doCreateUserWithEmailAndPassword = () => {

}

export const doSignInWithEmailAndPassword = () => {

}


// On duty / Off duty for a guard: {id, on_duty: true|false} -> {on_duty, duty_history, code 200}
export const setGuardOnDuty=(requestObj)=>{
    return sendRequest(
        'guard/setOnDuty',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// A guard's On / Off duty changes, 10 a page: {id, page} -> {rows, total, page, pages, timezone, on_duty, off_duty_since, code 200}
export const getGuardDutyHistory=(requestObj)=>{
    return sendRequest(
        'guard/dutyHistory',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Numbers already used in the company, while a phone number is typed (from 3 digits):
// {company_id, phone: as typed} -> {suggestions: [{phone, people: [{role, name}], label}], code 200}
export const getPhoneSuggestions=(requestObj)=>{
    return sendRequest(
        'people/phoneSuggestions',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// The Account page's Billing tab (laravel BillingController). The company admin gets their own company; the
// super admin sends company_id. {company_id?} -> {company, this_month, invoices, can_manage, online_payment, code 200}
export const getBillingOverview=(requestObj)=>{
    return sendRequest(
        'billing/overview',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// {id} -> {file_name, pdf_base64, code 200}
export const getInvoicePdf=(requestObj)=>{
    return sendRequest(
        'billing/invoicePdf',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Emails the invoice again to the company admin: {id} -> {message, invoice, code 200}
export const resendInvoice=(requestObj)=>{
    return sendRequest(
        'billing/resend',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// A paid invoice's receipt: {id} -> {file_name, pdf_base64, code 200}
export const getReceiptPdf=(requestObj)=>{
    return sendRequest(
        'billing/receiptPdf',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Super admin: what each void would do, changing nothing: {id} -> {invoice, waive, reissue, code 200}
export const voidInvoicePreview=(requestObj)=>{
    return sendRequest(
        'billing/voidPreview',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Super admin: void and make the corrected invoice: {id, reason} -> {message, result, invoice, void, code 200}
export const voidAndReissueInvoice=(requestObj)=>{
    return sendRequest(
        'billing/voidReissue',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Super admin: void; its duty starts are never charged: {id, reason} -> {message, void, code 200}
export const voidAndWaiveInvoice=(requestObj)=>{
    return sendRequest(
        'billing/voidWaive',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// The overdue banner: the company admin and its district managers -> {notice: null | {number, total_usd, due_label,
// stop_label, day, tone, stopped, pay_url}, code 200}
export const getBillingNotice=(requestObj)=>{
    return sendRequest(
        'billing/notice',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Super admin: the Billing page, every company: {period: YYYY-MM | year | all} -> {period, months, income, companies, freeagent, code 200}
export const getBillingCompanies=(requestObj)=>{
    return sendRequest(
        'billing/companies',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Super admin: the price per duty start and/or the billing start date of one or several companies
// {company_ids, rate_usd?, billing_starts_on?} (a field left out is kept; blank: the default / not billed yet) -> {message, code 200}
export const saveBillingTerms=(requestObj)=>{
    return sendRequest(
        'billing/saveTerms',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Super admin: FreeAgent (Martin's bookkeeping) on the Billing page (laravel FreeAgentController).
// {return_to} -> {url: where the browser goes to connect FreeAgent, code 200}
export const freeAgentConnect=(requestObj)=>{
    return sendRequest(
        'billing/freeAgentConnect',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Sends what is waiting now -> {message, result, lines, freeagent: status, code 200 (409: off, not connected, busy, paused)}
export const freeAgentSync=(requestObj)=>{
    return sendRequest(
        'billing/freeAgentSync',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Forgets the FreeAgent tokens -> {message, freeagent: status, code 200}
export const freeAgentDisconnect=(requestObj)=>{
    return sendRequest(
        'billing/freeAgentDisconnect',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Reseller commission (laravel CommissionController). The reseller's Commission page:
// {period: YYYY-MM | year | all} -> {companies, commission, paystack_url, owed_now_usd, can_submit, invoices, code 200}
export const getCommission=(requestObj)=>{
    return sendRequest(
        'billing/commission',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// The reseller's Paystack payment link: {paystack_url} -> {paystack_url, message, code 200 (400: not a Paystack https link)}
export const saveCommissionPaystack=(requestObj)=>{
    return sendRequest(
        'billing/commissionPaystack',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Submit invoice: all commission not invoiced yet, as one commission invoice to Mobiliis -> {invoice, message, code 200}
export const submitCommissionInvoice=(requestObj)=>{
    return sendRequest(
        'billing/commissionSubmit',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// A commission invoice's PDF (the reseller's own; the super admin any): {id} -> {file_name, pdf_base64, code 200}
export const getCommissionPdf=(requestObj)=>{
    return sendRequest(
        'billing/commissionPdf',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}

// Super admin: {id, paid_on: YYYY-MM-DD, reference} -> {result: paid | already_paid, invoice, message, code 200}
export const markCommissionPaid=(requestObj)=>{
    return sendRequest(
        'billing/commissionMarkPaid',
        requestMethod.POST,
        auth.FALSE,
        requestObj,
    )
}
